import { createCustomEnum, EnumItem } from "./customEnum";

type ResidualsStageStatusKeyValues =
	| "Pending"
	| "InProgress"
	| "Approved"
	| "Completed"
	| "Failed";

type ResidualsStageStatusEnumTypes = {
	[K in ResidualsStageStatusKeyValues]: EnumItem;
};

const ResidualsStageStatus = createCustomEnum<ResidualsStageStatusEnumTypes>({
	Pending: {
		value: "pending",
		name: "pending",
		displayName: "Pending",
	},
	InProgress: {
		value: "in_progress",
		name: "in_progress",
		displayName: "In progress",
	},
	Approved: {
		value: "approved",
		name: "approved",
		displayName: "Approved",
	},
	Completed: {
		value: "completed",
		name: "completed",
		displayName: "Completed",
	},
	Failed: {
		value: "failed",
		name: "failed",
		displayName: "Failed",
	},
});

export default ResidualsStageStatus;
